import { AuthContext } from 'src/services/auth/auth.types';
import { useGetAuthContextQuery } from 'src/services/auth/auth.service';

export const useAuthContext = () => {
  const { currentData: authContext } = useGetAuthContextQuery();

  return authContext as AuthContext;
};
